import axios from 'axios';
import * as Config from '../../config';
import { setToken, getToken } from '@/utils/tokenStorage';

const state = {
    token: '',       // ya no lo inicializamos con Cookies
    status: '',
    me: '',
    study: '',
    client: {},
    permissions: []
}

const actions = {
    async initToken({ commit }) {
        const token = await getToken();
        if (token) {
            state.token = token;
        }
    },

    google_auth_vincular({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'google-auth/vincular', form)
                .then(response => resolve(response))
                .catch(error => reject(error.response));
        });
    },

    google_auth_login({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'google-auth/login', form)
                .then(async response => {
                    const accessToken = response.data.access_token;
                    await setToken(accessToken);   // guardar usando sistema unificado
                    commit('MONO_LOGIN_OK', response.data);
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error.response);
                });
        });
    },

    setLoginMono({ commit }, data) {
        commit('MONO_LOGIN_OK', data);
    },
}

const mutations = {
    MONO_LOGIN_OK(state, data) {
        state.client = data.user;
        state.permissions = data.permissions;
        state.token = data.access_token;
        state.status = 'success';
    },
};

export default {
    state,
    actions,
    mutations
};
